<template>
  <el-row class="advice_container">
    <el-row class="t_l">
      <div class="advice_icon"></div>
      <br><br>
    </el-row>
    <el-form :model="rebackForm" status-icon :rules="rebackFormRules" ref="rebackForm" class="advice_form">
      <el-form-item label="您的写作领域" prop="business">
        <el-input type="text" v-model="rebackForm.business"></el-input>
      </el-form-item>
      <el-form-item label="您希望弈写做到......" prop="content">
        <el-input type="textarea" v-model="rebackForm.content" placeholder="" :rows=6 :show-word-limit=true
          resize="none"></el-input>
      </el-form-item>
      <el-form-item label="您的联系方式" prop="contact">
        <el-input v-model="rebackForm.contact" placeholder=""></el-input>
      </el-form-item>
      <div style="clear:both;height: 15px;"></div>
      <el-button type="primary" @click="submitReback" style="width:100%">确定</el-button>

    </el-form>
  </el-row>
</template>

<script>

export default {
  name: 'index',
  data: function () {
    return {

      rebackForm: {
        contact: '',
        content: '',
        business: ''
      },
      rebackFormRules: {
        // content: [
        //   { required: true, message: '反馈内容不能为空', trigger: 'blur' }
        // ]
      }
    }
  },
  methods: {
    submitReback () {
      let _this = this
      this.$refs.rebackForm.validate((valid) => {
        if (valid) {
          let temp = JSON.parse(JSON.stringify(_this.rebackForm))
          _this.axios.post('/webApi/m/feedback/add', temp).then(resp => {
            _this.$message({
              message: '信息反馈成功，谢谢!',
              type: 'success'
            })
          })
          _this.$emit('close')
        }
      })
    }

  },
  components: {

  },
  mounted () {

  },
  watch: {

  }
}
</script>
<style lang="less" >
.advice_container {

  .el-form-item {
    margin-bottom: 10px;
  }

  .advice_form {
    padding: 10px 40px;
  }

  .advice_icon {
    background-image: url("../assets/imgs/advice_icon.png");
    width: 33px;
    height: 33px;
    background-size: contain;
    display: inline-block;
    vertical-align: middle;
  }

  .advice_icon::after {
    content: "让小弈更好为您服务";

    height: 33px;
    width: 211px;
    background-size: contain;
    display: inline-block;
    vertical-align: middle;
    left: 43px;
    top: 2px;
    position: relative;
    font-size: 20px;
    color: #252525;
  }

  input,
  textarea {
    background-color: #F6F9FD;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/advice.vue